import Swiper from 'swiper'

import {
  EffectFade,
  EffectCoverflow,
  // FreeMode,
  Mousewheel,
  Navigation,
  Pagination,
  Thumbs,
} from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/mousewheel'
import 'swiper/css/effect-fade'

export default class Carousel {
  constructor(selector, options = {}, container) {
    this.elements = container
      ? container.querySelectorAll(selector)
      : document.querySelectorAll(selector)

    // console.log(selector, elements, container)

    this.elements.forEach((element, index) => {
      const navigation = {
        nextEl: element.querySelector('.swiper-button.is-next'),
        prevEl: element.querySelector('.swiper-button.is-prev'),
      }

      const slideCount = element.querySelectorAll('.swiper-slide').length
      const { minLoopSlides, ...swiperOptions } = options
      let isFew = false
      if (minLoopSlides !== undefined) {
        const willLoop = slideCount >= minLoopSlides
        swiperOptions.loop = willLoop
        // Too few slides to loop → on tablet+ lay all the (few) cards out in a
        // left-aligned row instead of the centered focus carousel (which
        // leaves a faded gap on the left). The cards then fit with no scroll,
        // so Swiper can no longer move its "active" slide on click — we drive
        // the highlight with a manual .is-focused class below (see the
        // .is-races.is-few rules in carousel.scss). MOBILE keeps the centered
        // swipe carousel: no breakpoint override below 768.
        if (!willLoop) {
          isFew = true
          swiperOptions.breakpoints = {
            ...(swiperOptions.breakpoints || {}),
            768: {
              centeredSlides: false,
              slidesPerView: slideCount,
              spaceBetween: 24,
            },
          }
        }
      }

      const swiper = new Swiper(element, {
        modules: [
          Navigation,
          Pagination,
          Mousewheel,
          // FreeMode,
          EffectFade,
          EffectCoverflow,
          Thumbs,
        ],
        mousewheel: {
          forceToAxis: true,
        },
        navigation,
        ...swiperOptions,
      })
      this.instances = swiper

      // Few-cards desktop layout: highlight the clicked card manually, since
      // Swiper's active slide is stuck when all the cards fit. On mobile the
      // .is-focused styling is dormant (tablet-gated CSS), so the centered
      // swipe carousel there is untouched.
      if (isFew) {
        element.classList.add('is-few')
        const slides = Array.from(element.querySelectorAll('.swiper-slide'))
        const setFocus = (index) =>
          slides.forEach((slide, i) =>
            slide.classList.toggle('is-focused', i === index),
          )
        slides.forEach((slide, i) =>
          slide.addEventListener('click', () => setFocus(i)),
        )
        setFocus(0)
      }
    })
  }
}
